<template>
  <div>
    <div id="map"></div>
    <div class="menu">
      <div
        class="item"
        v-for="item in typeList"
        :key="item.value"
        :class="selected === item.value ? 'active' : ''"
        @click="onSelect(item.value)"
      >{{ item.name }}</div>
    </div>

    <ThisDetail :detail="detail" />
  </div>
</template>
<script>
import ThisDetail from "./components/detail.vue";
import request from "@/api/request";
import { typeList } from "./data";

export default {
  components: {
    ThisDetail,
  },

  data() {
    return {
      typeList,
      list: [],
      detail: {},
      selected: "",
    };
  },

  watch: {
    selected() {
      this.list = [];
      this.detail = {};
      if (this.selected === "liquid_level") {
        this.getLiquid();
      } else {
        this.getFlow();
      }
    },
    list: {
      handler() {
        if (this.list.length > 0) {
          this.detail = this.list[0];
          this.setMarker();
        }
      },
      deep: true,
    },
    detail: {
      handler() {
        if (this.detail.id) {
          this.setMarker();
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.initMap();
    this.selected = "liquid_level";
  },

  beforeDestroy() {
    this.markers?.forEach((item) => {
      item.off("click", this.onMarkerClick);
    });
    this.map?.clearMap();
    this.map?.destroy();
  },

  methods: {
    initMap() {
      const { AMap } = window;
      if (!AMap) {
        return;
      }
      var map = new AMap.Map("map", {
        center: [118.536766,32.993047],
        zoom: 17,
        // mapStyle: "amap://styles/f3c7464cbaf52050e35d00dc506f4069",
        mapStyle: "amap://styles/light",
        WebGLParams: {
          preserveDrawingBuffer: true,
        },
      });

      this.map = map;

      AMap.plugin(["AMap.Scale", "AMap.HawkEye", "AMap.MapType"], function () {
        map.addControl(new AMap.Scale());
        map.addControl(new AMap.HawkEye({ isOpen: true ,mapStyle: "amap://styles/light",}));
        map.addControl(new AMap.MapType());
      });
    },

    onSelect(key) {
      this.selected = key;
    },

    getLiquid() {
      request({
        url: "/model-analysis/pipe/device/query/realtime/type/liquidLevel",
      }).then((res) => {
        console.log("res", res);
        if (Array.isArray(res)) {
          this.list = res;
        }
      });
    },

    getFlow() {
      request({
        url: "/model-analysis/pipe/device/query/realtime/type/flowMeter",
      }).then((res) => {
        console.log("res", res);
        if (Array.isArray(res)) {
          this.list = res;
        }
      });
    },

    setMarker() {
      // 先清除原来地图上的标记
      this.markers?.forEach((item) => {
        item.off("click", this.onMarkerClick);
      });
      this.markers = [];
      this.map?.clearMap();

      if (this.selected == "liquid_level") {
        const markers = this.list.map((item) => {
          let content = "";
          if (item.id === this.detail.id) {
            content = `
                <div style="background-color: #fff;white-space: nowrap;border-radius: 100px;border: 2px solid #f00;line-height: 32px;font-size: 14px;display: flex;align-items: center; padding: 0 8px ">
                      <img src='/icon/liquid-active.png' style="height: 18px;margin-right: 8px;border-radius: 50%;border: 2px solid #f00"  />
                    <span style='color: #f00'>${item.name}：${item.realtime.liquidLevel}m</span>
              </div>
              `;
          } else {
            content = `
                    <div style="background-color: #fff;white-space: nowrap;border-radius: 100px;border: 2px solid #ff6e21;line-height: 32px;font-size: 14px;display: flex;align-items: center; padding: 0 8px ">
                      <img src='/icon/liquid-active.png' style="height: 18px;margin-right: 8px"  />
                    <span>${item.name}：${item.realtime.liquidLevel}m</span>
              </div>
          `;
          }

          const marker = new window.AMap.Marker({
            position: [item.x, item.y],
            content,
            extData: item,
          });

          marker.on("click", this.onMarkerClick);
          return marker;
        });

        this.map.add(markers);
        this.markers = markers;
      } else {
        /** 在流速页面只显示 */
        const flow_meters = this.list.filter((item) => {
          return item.type == "flowMeter";
        });
        const markers = flow_meters.map((item) => {
          let content = "";
          if (item.id === this.detail.id) {
            content = `
                    <div style="background-color: #fff;white-space: nowrap;border-radius: 100px;border: 2px solid #f00;line-height: 32px;font-size: 14px;display: flex;align-items: center; padding: 0 8px ">
                      <img src='/icon/flow-active.png' style="height: 18px;margin-right: 8px;border-radius: 50%;border: 2px solid #f00"  />
                    <span style='color: #f00'>${item.name}：${item.realtime.flowspeed}m/s</span>
              </div>
              `;
          } else {
            content = `
                 <div style="background-color: #fff;white-space: nowrap;border-radius: 100px;border: 2px solid #ffabaf;line-height: 32px;font-size: 14px;display: flex;align-items: center; padding: 0 8px ">
                      <img src='/icon/flow-active.png' style="height: 18px;margin-right: 8px"  />
                    <span>${item.name}：${item.realtime.flowspeed}m/s</span>
              </div>
          `;
          }

          const marker = new window.AMap.Marker({
            position: [item.x, item.y],
            content,
            extData: item,
          });

          marker.on("click", this.onMarkerClick);
          return marker;
        });

        this.map.add(markers);
        this.markers = markers;
      }
    },

    onMarkerClick(e) {
      console.log(e);
      this.detail = e.target._opts.extData;
    },
  },
};
</script>


<style lang="less" scoped>
#map {
  position: fixed;
  height: 105vh;
  width: 100vw;
  left: 0;
  top: 0;
}

.menu {
  position: fixed;
  top: 11vh;
  left: 1vw;
  background-color: #090d23;
  border-radius: 8px;
  //padding: 1vh;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #065747;
  color:#adadad;
  padding: 0.8rem;

  .item {
    padding: 4px 12px;
  }

  .active {
    background-color: rgba(0, 255, 150, 0.2);
    border-radius: 6px;
    color: #00ff96;
    border-bottom: 1px solid #00ff96;
  }
}

::v-deep .amap-ctrl-icon-layer,::v-deep  .amap-ctrl-list-layer{
  background-color: #091027;
  border-radius: 3px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, .2);
  border: 1px solid #065645;
  color: #d7d7d7;
}
::v-deep .amap-ctrl-base-layer{
  border-bottom: 1px solid #065645;
}
</style>